import { ChangeDetectionStrategy, Component, computed, inject, input, model, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { SdButtonIconComponent } from '../../buttons/button-icon/button-icon.component';
import { PositionEnum } from '../../../_enums/position.enum';
import { SdModalComponent } from '../modal/modal.component';
import { IconSizeEnum } from '../../../_enums/icon.enum';
import { ThemesEnum } from '../../../_enums/themes.enum';
import { BrandsEnum } from '../../../_enums/brands.enum';
import { ModalType } from '../modal/modal.enum';
import { CoreModalService } from '../core-modal/core-modal.service';
import { DeviceService } from '../../../_services/device.service';

@Component({
  selector: 'sd-modal-aside',
  templateUrl: './modal-aside.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdModalComponent,
    SdButtonIconComponent
  ],
  providers: [CoreModalService]
})
export class SdModalAsideComponent {
  brand = input<BrandsEnum>();
  /**
   * Manage opening / close of the modal
   * When set to true, the modal will open
   */
  isOpened = model(false);
  noPadding = input(false);
  /**
   * Manage the modal position, either left or right
   */
  modalPositionInput = input<PositionEnum.left | PositionEnum.right>(PositionEnum.right);
  /**
   * Custom Class for the modal (in the CDK overlay)
   */
  asideClass = input('');
  /**
   * Custom Id for the modal (in the CDK overlay)
   */
  asideId = input('');
  /**
   * Either the modal has a backdrop or not
   */
  backdrop = input<boolean>();

  /**
   * Event emitter telling to the outside world the current state of the modal
   */
  isOpenedChange = output<boolean>();

  private readonly deviceService = inject(DeviceService);

  isMobile = toSignal(this.deviceService.isMobile);

  modalPosition = computed(() =>
    this.isMobile() ? PositionEnum.bottom : this.modalPositionInput()
  );

  protected readonly iconSize = IconSizeEnum;
  protected readonly themesEnum = ThemesEnum;

  _type = ModalType.aside;

  onClickCloseBtn() {
    this.isOpened.set(false);
    this.isOpenedChange.emit(this.isOpened());
  }

  onOpenedChange() {
    this.isOpenedChange.emit(this.isOpened());
  }
}
